<template lang="pug">
    el-dialog(:title="!dataForm.id ? '新增' : '修改'", class="el-dialog-custom", top="3vh", width="95%", :close-on-click-modal='false', :append-to-body="true" :visible.sync='visible' :modal-append-to-body='false' @close="dialog_close")
      el-form(:model='dataForm',  :rules='dataRule', ref='dataForm', label-suffix=":" label-width="100px" )
        el-card(shadow="never")
          div(slot="header")
            font(style="font-weight: bold;font-size:18px;") {{!dataForm.id ? '新增资讯' : '修改资讯'}}
          div
            el-form-item(label='标题', prop='title1')
              el-input.width_ct(v-model='dataForm.title1', placeholder='请填写资讯标题')
            el-form-item(label='摘要', prop='summary')
                el-input.width_ct(type='textarea' v-model='dataForm.summary' maxlength="200" show-word-limit :rows=6 resize="none" placeholder='请填写摘要')
            el-form-item(label='公众号链接', prop='officialAccountLink')
              el-input.width_ct(v-model='dataForm.officialAccountLink', maxlength="100", clearable, placeholder='例：https://mp.weixin.qq.com/s/123456789')
            el-form-item(label='资讯类型', prop='type')
              el-select.sel_width_ct(v-model="dataForm.type",placeholder="请选择资讯类型" clearable)
                el-option(label="培训",value="1")
                el-option(label="竞赛",value="2")
                el-option(label="活动",value="3")
                //- el-option(label="专栏",value="4")
                el-option(label="图片直播",value="4")
            el-form-item(label='主办方', prop='orgId')
              el-select.sel_width_ct(v-model="dataForm.orgId", placeholder="请选择主办方" filterable clearable)
                el-option(v-for="(item,index) in sysOrgList",:key="index",:label="item.name",:value="item.orgId")
            el-form-item(label='发布日期', prop='date')
              el-date-picker.sel_width_ct(v-model="dataForm.date" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="timestamp")
            el-form-item(label="缩略图" prop="headImg")
              el-input(v-model="dataForm.headImg" v-show="false")
              //- el-upload(:http-request="uploadSectionFile",action="useless" :headers="headers", :before-upload="beforeAvatarUpload" :show-file-list="false" class="avatar-uploader")
              //-   img(v-if="imageUrl" :src="imageUrl" class="avatar" )
              //-   i(v-else class="el-icon-plus avatar-uploader-icon")
              div(style="width:240px;height:180px;margin-top:12px;")
                img(v-if="imageUrl" :src="imageUrl" @click="openImgdailog" style="width:100%")
                i(v-else class="el-icon-plus avatar-uploader-icon" @click="openImgdailog" style="width:240px;height:180px;")
              imgupload(v-if="openImg" ref="upimg" :width="240" :height="180" @uploadSuccess='doneup')
            el-form-item(label='是否顶置', prop='is_top')
              el-select.sel_width_ct(v-model="dataForm.is_top" clearable)
                el-option(label="是",value="1")
                el-option(label="否",value="2")
            el-form-item(label='内容')
              d2-quill(v-show="showQuill" style="min-height: 200px;" ref="d2-quill" v-model="dataForm.content")
      span.dialog-footer(slot='footer')
        el-button(@click='visible = false') 取消
        el-button(v-if="dataForm.id" type='primary', @click='dataFormSubmit') 保存修改
        el-button(v-else type='primary', @click='dataFormSubmit') 确定
</template>

<script>
import util from '@/libs/util.js'
export default {
  data () {
    return {
      visible: false,
      sysOrgList: [],
      imageUrl: '',
      openImg: '',
      dataForm: {
        id: '',
        title1: '',
        officialAccountLink: '',
        date: '',
        type: '',
        orgId: '',
        is_top: '2',
        summary: '',
        content: '',
        headImg: ''
      },
      loading: null,
      dataRule: {
        title1: [
          { required: true, message: '资讯标题不能为空！', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '资讯类型不能为空！', trigger: 'blur' }
        ],
        orgId: [
          { required: true, message: '主办方不能为空！', trigger: 'blur' }
        ],
        date: [
          { required: true, message: '发布日期不能为空！', trigger: 'blur' }
        ],
        headImg: [{ required: true, message: '必须上传缩略图！', trigger: 'blur' }]
      },
      headers: {
        token: util.cookies.get('token'),
        authorization: 'Bearer ' + util.cookies.get('authorization'),
        'Content-Type': 'application/json; charset=utf-8'
      },
      showQuill: false // 这个字段是用来解决Quill富文本编辑器在初始化后会自动聚焦从而导致页面自动滚动的bug
    }
  },

  methods: {
    init (id) {
      this.imageUrl = ''
      this.dataForm.id = id || null
      this.$http({
        url: this.$http.adornUrl('/sysOrg/list'),
        method: 'get',
        params: this.$http.adornParams()
      })
        .then(data => {
          this.sysOrgList = data && data.code === 0 ? data.list : []
        })
        .then(() => {
          this.$nextTick(() => {
            this.visible = true
            // console.log("this.$refs['ruleForm']:",this.$refs['ruleForm'])
            if (this.$refs['dataForm']) {
              this.$refs['dataForm'].resetFields()
              this.$refs['d2-quill'].Quill.pasteHTML('')
            }
          })
        })
        .then(() => {
          if (this.dataForm.id) {
            this.$http({
              url: this.$http.adornUrl(`/pbNews/getId/${this.dataForm.id}`),
              method: 'get',
              params: this.$http.adornParams()
              }).then((data) => {
                  if (data && data.code === 0) {
                    this.dataForm.title1 = data.bean.title
                    this.dataForm.summary = data.bean.summary
                    this.dataForm.officialAccountLink = data.bean.officialAccountLink
                    this.dataForm.type = data.bean.type + ''
                    this.dataForm.orgId = data.bean.orgId
                    this.dataForm.headImg = data.bean.img
                    this.dataForm.is_top = data.bean.isTop + ''
                    this.$refs['d2-quill'].Quill.pasteHTML(data.bean.content)
                    setTimeout(() => {
                      this.showQuill = true
                    }, 500)
                    this.dataForm.date = new Date(data.bean.publishTime).getTime()
                    console.log(this.dataForm.date)

                    if (data.bean.imgUrl != '' && data.bean.imgUrl != null) {
                        this.imageUrl = data.bean.imgUrl
                    }
                  }
              })
          } else {
            setTimeout(() => {
              this.showQuill = true
            }, 500)
          }
        })
    },
    //文件上传前的验证
    beforeAvatarUpload (file) {
      const isJPG =
        file.type === 'image/jpg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传图片只能是 jpg,jpeg,png 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    //自定义上传方法
    //没有用el-upload的action方法，如果使用要传递headers属性参数授权
    uploadSectionFile (param) {
      let fd = new FormData()
      fd.append('type', 'pbNews')
      fd.append('file', param.file)

      this.$http({
        url: this.$http.adornUrl(`/upload/uploadFile`),
        method: 'post',
        data: fd
      }).then(data => {
        if (data && data.code === 0) {
          this.dataForm.headImg = data.bean.id
          this.imageUrl = URL.createObjectURL(param.file)
          this.dataForm.byx3 = '0'
          this.$message.success('上传成功!')
        } else {
          this.$message.error('上传失败!')
        }
      })
    },
    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    openImgdailog () {
      this.openImg = true
      this.$nextTick(() => {
          this.$refs.upimg.init('pbNews') //传入图片类型参数
      })
    },
    doneup (val, url) {
      this.dataForm.headImg = val
      this.imageUrl = url
    },
    // 表单提交
    dataFormSubmit () {
      const data = {
        id: this.dataForm.id || '',
        title: this.dataForm.title1,
        officialAccountLink: this.dataForm.officialAccountLink,
        type: this.dataForm.type,
        publishTime: this.dataForm.date,
        img: this.dataForm.headImg,
        isTop: this.dataForm.is_top,
        orgId: this.dataForm.orgId,
        summary: this.dataForm.summary,
        content: this.dataForm.content
      }
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          this.openFullScreen()
          this.$http({
            url: this.$http.adornUrl(
              `/pbNews/${!this.dataForm.id ? 'save' : 'update'}`
            ),
            method: 'post',
            data: data
          })
            .then(data => {
              this.loading.close()
              if (data && data.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.visible = false
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch(() => {
              this.loading.close()
            })
        }
      })
    },
    dialog_close () {
      this.showQuill = false
    }
  }
}
</script>

<style scoped>
.el-dialog-custom {
  overflow: hidden !important;
}
.el-dialog-custom /deep/ .el-dialog__body {
  height: 73vh;
  overflow: auto;
}
.el-dialog-custom /deep/ .el-dialog__footer {
  border-top: 1px solid #E9E9E9;
}
</style>

<style>
.width_ct {
  width: 50%;
}
.sel_width_ct,
.input_width_ct {
  width: 20% !important;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #ccc
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.dialog-footer {
  padding-bottom: 150px;
}

/* 文本框剩余数字提示兼容ie */
.el-textarea .el-input__count {
    color: #909399;
    background: none;
    position: absolute;
    font-size: 12px;
    bottom: 5px;
    right: 25px;
}
</style>
